export const colors = {
  amber: {
    DEFAULT: '#F59F0B',
    50: '#FEF5E7',
    100: '#FDECCE',
    200: '#FBD99D',
    300: '#F9C56C',
    400: '#F7B23B',
    500: '#F59F0B',
    600: '#C47F08',
    700: '#935F06',
    800: '#624004',
    900: '#312002',
  },

  aqua: {
    DEFAULT: '#11B496',
    50: '#E8FDF9',
    100: '#D0FBF3',
    200: '#A2F6E7',
    300: '#73F2DB',
    400: '#45EDCE',
    500: '#11B496',
    600: '#12BA9B',
    700: '#0D8C75',
    800: '#095D4E',
    900: '#042F27',
  },

  blue: {
    DEFAULT: '#346BF5',
    50: '#E7EDFE',
    100: '#CEDBFD',
    200: '#9EB8FA',
    300: '#6D94F8',
    400: '#3D71F5',
    500: '#346BF5',
    600: '#0A3EC2',
    700: '#072E92',
    800: '#051F61',
    900: '#020F31',
  },

  ['blue-secondary']: {
    DEFAULT: '#0EA4E9',
    50: '#E7F6FE',
    100: '#CFEEFC',
    200: '#9FDDF9',
    300: '#6FCBF6',
    400: '#3FBAF3',
    500: '#0EA4E9',
    600: '#0C87C0',
    700: '#096590',
    800: '#064460',
    900: '#032230',
  },

  brown: {
    DEFAULT: '#AA6600',
    50: '#FFF5E5',
    100: '#FFEBCC',
    200: '#D4BB9E',
    300: '#D39A43',
    400: '#BF842C',
    500: '#AA6600',
    600: '#995C00',
    700: '#955404',
    800: '#663D00',
    900: '#331F00',
  },

  cyan: {
    DEFAULT: '#00BBD4',
    50: '#E5FCFF',
    100: '#CCF9FF',
    200: '#99F3FF',
    300: '#66EDFF',
    400: '#33E7FF',
    500: '#00BBD4',
    600: '#00B4CC',
    700: '#008799',
    800: '#005A66',
    900: '#002D33',
  },

  green: {
    DEFAULT: '#70BA10',
    50: '#F4FDE8',
    100: '#E8FBD0',
    200: '#D2F7A1',
    300: '#BBF372',
    400: '#A4EF43',
    500: '#70BA10',
    600: '#71BC10',
    700: '#558D0C',
    800: '#395E08',
    900: '#1C2F04',
  },

  indigo: {
    DEFAULT: '#6876F5',
    50: '#E7E9FD',
    100: '#CFD4FC',
    200: '#9FA8F9',
    300: '#6F7DF6',
    400: '#4052F2',
    500: '#6876F5',
    600: '#0D1FBF',
    700: '#091790',
    800: '#060F60',
    900: '#030830',
  },

  lime: {
    DEFAULT: '#CCDC39',
    50: '#F9FBE9',
    100: '#F4F7D4',
    200: '#E9F0A8',
    300: '#DDE87D',
    400: '#D2E052',
    500: '#CCDC39',
    600: '#9FAD1F',
    700: '#778217',
    800: '#50570F',
    900: '#282B08',
  },

  orange: {
    DEFAULT: '#F89215',
    50: '#FEF3E6',
    100: '#FEE8CD',
    200: '#FCD19C',
    300: '#FBBA6A',
    400: '#F9A339',
    500: '#F89215',
    600: '#C67006',
    700: '#955404',
    800: '#633803',
    900: '#321C01',
  },

  ['orange-secondary']: {
    DEFAULT: '#F97416',
    50: '#FEF0E6',
    100: '#FEE1CD',
    200: '#FCC49C',
    300: '#FBA66A',
    400: '#FA8938',
    500: '#F97416',
    600: '#C75605',
    700: '#954004',
    800: '#632B03',
    900: '#321501',
  },

  pink: {
    DEFAULT: '#9C27B0',
    50: '#F8EAFA',
    100: '#F1D5F6',
    200: '#E3ACEC',
    300: '#D582E3',
    400: '#C658DA',
    500: '#9C27B0',
    600: '#9325A7',
    700: '#6F1C7D',
    800: '#4A1353',
    900: '#25092A',
  },

  ['pink-secondary']: {
    DEFAULT: '#F844D7',
    50: '#FFE5FA',
    100: '#FFCCF6',
    200: '#FF99EC',
    300: '#FF7CE7',
    400: '#FF66E3',
    500: '#F844D7',
    600: '#CC00A7',
    700: '#99007D',
    800: '#660053',
    900: '#33002A',
  },

  purple: {
    DEFAULT: '#5E3BE8',
    50: '#ECE8FC',
    100: '#D9D1FA',
    200: '#B4A4F4',
    300: '#8E76EF',
    400: '#6948EA',
    500: '#5E3BE8',
    600: '#3615B7',
    700: '#281089',
    800: '#1B0B5B',
    900: '#0D052E',
  },

  ['purple-secondary']: {
    DEFAULT: '#9233EA',
    50: '#F3E8FD',
    100: '#E6D1FA',
    200: '#CDA3F5',
    300: '#B574F1',
    400: '#9C46EC',
    500: '#9233EA',
    600: '#6913B9',
    700: '#4F0E8B',
    800: '#340A5C',
    900: '#1A052E',
  },

  steel: {
    DEFAULT: '#475569',
    50: '#F0F2F5',
    100: '#E1E5EA',
    200: '#C2CAD6',
    300: '#A4B0C1',
    400: '#8596AD',
    500: '#475569',
    600: '#52637A',
    700: '#3E4A5B',
    800: '#29313D',
    900: '#15191E',
  },

  stone: {
    DEFAULT: '#57534E',
    50: '#F3F2F2',
    100: '#E7E6E4',
    200: '#CFCCC9',
    300: '#B7B3AE',
    400: '#9F9A93',
    500: '#57534E',
    600: '#6C6760',
    700: '#514D48',
    800: '#363330',
    900: '#1B1A18',
  },

  yellow: {
    DEFAULT: '#F1BF09',
    50: '#FEF9E6',
    100: '#FEF3CD',
    200: '#FCE79C',
    300: '#FBDC6A',
    400: '#FAD038',
    500: '#F1BF09',
    600: '#C79D05',
    700: '#957604',
    800: '#634E03',
    900: '#322701',
  },
};

export type TaskColor = keyof typeof colors;

export const keys = Object.keys(colors) as TaskColor[];
